<template>
    <v-container fluid class="pa-1 ma-1">
        <v-row dense>
            <v-col>
                <v-card flat>
                    <v-card-title>
                        {{ $t('labels.languages') }}
                    </v-card-title>
                    <v-card-text>
                        <v-simple-table>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="text-left">{{ $t('fields.language') }}</th>
                                        <th class="text-left">{{ $t('fields.rating') }}</th>
                                        <th class="text-left">{{ $t('fields.level') }}</th>
                                        <th class="text-left" v-if="inEditMode">{{ $t('buttons.delete') }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in items" :key="index">
                                        <td>{{ item.language_display }}</td>
                                        <td class="pl-2">
                                            <v-rating
                                                :readonly="!inEditMode"
                                                v-model="item.level"
                                                color="primary"
                                                background-color="grey darken-1"
                                                length="4"
                                                size="30"
                                            ></v-rating>
                                        </td>
                                        <td>
                                            {{ levelString(item.level) }}
                                        </td>
                                        <td class="pl-1">
                                            <v-btn
                                                v-if="inEditMode"
                                                class="ml-2 mr-2 mt-1"
                                                color="secondary"
                                                @click="removeLanguage(index)"
                                            >
                                                <v-icon small>fa-trash</v-icon>
                                            </v-btn>
                                        </td>
                                    </tr>
                                    <tr v-if="!inEditMode && items.length == 0">
                                        <td colspan="3" class="text--secondary">{{ $t('labels.noData') }}</td>
                                    </tr>
                                    <tr v-if="inEditMode">
                                        <td class="pl-1">
                                            <Dropdown
                                                v-model="languageObject.language_id"
                                                :ajax="true"
                                                :data="'languages'"
                                                :errorBorder="!languageObjectValidation.language_id"
                                                :label="'* ' + $t('fields.language')"
                                                @selected="selectedLanguage"
                                            ></Dropdown>
                                        </td>
                                        <td class="pl-1">
                                            <v-rating
                                                :item-labels="['sad', '', '', '', 'happy']"
                                                v-model="languageObject.level"
                                                color="primary"
                                                background-color="grey darken-1"
                                                hover
                                                length="4"
                                                size="35"
                                            ></v-rating>
                                        </td>
                                        <td class="pl-1">
                                            {{ level }}
                                        </td>
                                        <td class="pl-1">
                                            <v-btn class="ml-2 mr-2 mt-1" color="primary" @click="addLanguage()">
                                                <v-icon small>fa-plus</v-icon>
                                            </v-btn>
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row><v-col></v-col></v-row>
    </v-container>
</template>

<script>
import Dropdown from '@/components/trinkets/Dropdown';
import SeafarerLanguage from '../models/SeafarerLanguage';

export default {
    name: 'SeafarerLanguages',
    components: {Dropdown},
    data: function () {
        return {
            languageObject: new SeafarerLanguage({}),
            languageObjectValidation: new SeafarerLanguage({}, true),
        };
    },
    props: ['seafarer', 'initialLoad', 'inEditMode', 'languagesItems'],
    emits: ['pending'],
    computed: {
        items: {
            get() {
                return this.languagesItems;
            },
            set(newItem) {
                return newItem;
            },
        },
        level() {
            return this.levelString(this.languageObject.level);
        },
        isPendingEmpty() {
            return (
                (this.languageObject.language_id == '' || this.languageObject.language_id == null) &&
                this.languageObject.level == null
            );
        },
    },
    methods: {
        // Poziva se iz SeafarerAdditional@saveClick: ispunjen red preuzmi, djelomično ispunjen blokira spremanje.
        commitPending() {
            if (this.isPendingEmpty) return true;
            return this.addLanguage(true);
        },
        resetPending() {
            this.languageObject = new SeafarerLanguage({});
            this.languageObjectValidation = new SeafarerLanguage({}, true);
        },
        addLanguage(fromSave = false) {
            let success = true;

            if (this.languageObject.language_id == '' || this.languageObject.language_id == null) {
                success = false;
                this.languageObjectValidation.language_id = false;
                if (fromSave) this.$alert(this.$t('alerts.pendingRowInvalid'));
            } else {
                this.languageObjectValidation.language_id = true;
            }
            this.items.forEach((element) => {
                if (this.languageObject.language_id == element.language_id) {
                    success = false;
                    this.$alert(this.$t('alerts.languageAlreadyAdded'));
                }
            });
            if (this.languageObject.level == null) {
                this.$alert(this.$t('alerts.selectLevel'));
                success = false;
            }

            if (success) {
                this.items.push(this.languageObject);
                this.languageObject = new SeafarerLanguage({});
            }
            return success;
        },
        selectedLanguage(value) {
            this.languageObject.language_display = value.label;
        },
        levelString(level) {
            if (level == 1) {
                return this.$t('fields.noProfficiency');
            } else if (level == 2) {
                return this.$t('fields.poor');
            } else if (level == 3) {
                return this.$t('fields.good');
            } else if (level == 4) {
                return this.$t('fields.fluent');
            } else {
                return '';
            }
        },
        removeLanguage(index) {
            this.items.splice(index, 1);
        },
    },
    watch: {
        isPendingEmpty(value) {
            this.$emit('pending', !value);
        },
    },

    mounted() {
        if (!this.$myStore.state.loggedIn) {
            this.$router.replace('login');
        }
    },
};
</script>

<style scoped></style>
